<form #filterForm="ngForm" class="mt-3">
    <div class="row">
        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-date name="filterDateFrom"
                          [(ngModel)]="filterValues.dateFrom"
                          [placeholder]="'healthMinistryDashboard_lblPeriodFrom' | translate"
                          [max]="filterValues.dateTo"
                          (dateChange)="filter()"></app-date>
            </div>
        </div>

        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-date name="filterDateTo"
                          [(ngModel)]="filterValues.dateTo"
                          [placeholder]="'healthMinistryDashboard_lblPeriodTo' | translate"
                          [min]="filterValues.dateFrom"
                          (dateChange)="filter()"></app-date>
            </div>
        </div>

        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-select name="filterStatus"
                            [options]="filters.status"
                            [placeholder]="'healthMinistryDashboard_lblStatus' | translate"
                            [(ngModel)]="filterValues.status"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-select name="filterSpeciality"
                            [options]="filters.speciality"
                            [placeholder]="'healthMinistryDashboard_lblSpeciality' | translate"
                            [(ngModel)]="filterValues.speciality"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-select name="filterWorkplace"
                            [options]="filters.workplace"
                            [placeholder]="'healthMinistryDashboard_lblWorkplace' | translate"
                            [(ngModel)]="filterValues.workplace"
                            [filter]="true"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-md-4 col-sm-6">
            <div class="form-field">
                <app-select name="filterClinicalBase"
                            [options]="filters.clinicalBase"
                            [placeholder]="'healthMinistryDashboard_lblClinicalBase' | translate"
                            [(ngModel)]="filterValues.clinicalBase"
                            [filter]="true"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>
    </div>
</form>

<div class="totals row">
    <div class="col-sm-6 col-md-3" *ngFor="let n of totals">
        <div class="data-value total-item">
            <label>{{n.label}}</label>
            <div>{{n.value}}</div>
        </div>
    </div>
</div>

<div class="charts">
    <div class="chart-box" *ngFor="let c of charts">
        <div class="chart">
            <h3 class="h-xs mb-0">{{c.title}}</h3>
            <div *ngIf="!c.data.length" class="text-mute text-sm mt-1">
                {{'healthMinistryChart_noEntries' | translate}}
            </div>
            <div class="chart-container" id="chart-{{c.id}}">
                <canvas id="{{c.id}}">{{c.chart}}</canvas>
            </div>
            <div class="legend" [class.legend-long]="hasLongLabels(c.data)" *ngIf="c.data.length">
                <div *ngFor="let n of c.data; let i = index" class="legend-item">
                    <span class="legend-color" [style.background]="colors[i]"></span>
                    <span class="legend-text" [title]="n.label">{{n.label}}</span>
                    <span class="legend-value">&nbsp;- {{n.value}} ({{n.percents}}%)</span>
                </div>
            </div>
        </div>
    </div>
</div>
